export const RegexMixin = {
    data() {
        return {
            urlRegex: { regex: /(https?:\/\/)?([\w-])+\.{1}([a-zA-Z]{2,63})([/\w-]*)*\/?\??([^#\n\r]*)?#?([^\n\r]*)/},
            frenchRegex: { regex: /^[0-9a-zA-Z\u00C0-\u00FF' ]*$/},
        }
    },
}